
export class FetchRMReleasesMatching{
    static readonly type = '[FETCH RMRELEASES] Fetch RM Products Matching text';
    constructor(public payload: any, public productName: any) {}
}

export class ClearRMReleasesMatching{
    static readonly type = '[CLEAR RMRELEASES] Clear RM Releases Suggested';
}
